'use strict';

/**
 * Component for the proper name
 *
 * @category   View
 * @module     collection.edit
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var LayoutView = require('base/Colido.LayoutView');

var template = require('../../../templates/components/detail/field-dimension-type.hbs');

var DimensionTypeComponent = LayoutView.extend({
    template: template,

    className: function() {
        var field = this.getOption('field');

        return 'component-' + _.camelToHyphen(field.type);
    },

    viewData: {
        field: function() {
            return this.getOption('field');
        },
    },

    getText: function() {
        var field = this.getOption('field');

        return this.model.getTextValue(field.name);
    },

    hasValue: function() {
        var field = this.getOption('field');

        return this.model.get(field.name) ? true : false;
    },
});

module.exports = DimensionTypeComponent;